// extracted by mini-css-extract-plugin
export default {"text":"ServicePages--text--2W5jW","subtitle":"ServicePages--subtitle--2FnB1","section--title":"ServicePages--section--title--RFcIH"};